<template>
  <main class="min-h-screen bg-app">
    <div class="placeholder__image h-56 bg-soft mb-8" />
    <div class="w-full">
      <span class="placeholder placeholder__title mb-8" />
      <span class="placeholder placeholder__intro" />
      <span class="placeholder placeholder__intro" />
      <span class="placeholder placeholder__intro" />
      <span class="placeholder placeholder__intro" />
      <span class="placeholder placeholder__intro" />
      <span class="placeholder placeholder__intro mb-8" />
      <span class="placeholder placeholder__text" />
      <span class="placeholder placeholder__text" />
      <span class="placeholder placeholder__text" />
      <span class="placeholder placeholder__text" />
      <span class="placeholder placeholder__text" />
      <span class="placeholder placeholder__text mb-5" />
      <span class="placeholder placeholder__text" />
      <span class="placeholder placeholder__text" />
    </div>
  </main>
</template>

<script>
// import Container from '@/components/container/Container.vue'

export default {
  name: 'LoadingState',
  components: {
    // Container
  }
}
</script>

<style lang="scss" scoped>
.placeholder,
.placeholder__image {
  position: relative;
  display: block;
  @apply overflow-hidden;

  &::before {
    content: '';
    @apply absolute inset-0 bg-white opacity-30;
    animation: blink 4s infinite cubic-bezier(.645, .045, .355, 1);
  }
}

.placeholder {
  @apply bg-soft rounded;

  @for $i from 1 through 15 {
    &:nth-of-type(#{$i}) {
      margin-right: #{random(64)}px;
    }
  }

  &:nth-of-type(even) {
    @apply opacity-50;
  }

  &:not([class*="mb-"]) {
    @apply mb-1;
  }

  &__title {
    @apply h-6;
  }

  &__intro {
    @apply h-4;
  }

  &__text {
    @apply h-3;
  }
}
@keyframes blink {
  0%, 100% {
    opacity: 0.25;
    transform: translate3d(-100%, 0, 0);
  }
  30% {
    opacity: 0.25;
    transform: translate3d(100%, 0, 0);
  }
  31% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  32% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
</style>

<docs>
  ```jsx
    <div>
      <loading-state />
    </div>
  ```
</docs>
